"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GPSbutton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const sdk_core_1 = require("@streem/sdk-core");
const room_session_1 = require("../../../../context/room_session");
const rxjs_1 = require("../../../../hooks/rxjs");
const operators_1 = require("rxjs/operators");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
function GPSbutton() {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [requestTimedOut, setRequestTimedOut] = (0, react_1.useState)(false);
    const [disabled, setDisabled] = (0, react_1.useState)(false);
    const [gpsResponse] = (0, rxjs_1.useObservable)(roomSession.geolocation.responses.pipe((0, operators_1.map)(responses => responses[responses.length - 1])));
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const [isLockedOpen, setIsLockedOpen] = (0, react_1.useState)(false);
    const requestGeolocation = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        const id = roomSession.geolocation.requestGeolocation();
        try {
            setRequestTimedOut(false);
            setDisabled(true);
            yield (0, sdk_core_1.artifactTimedResponse)(id, roomSession.geolocation.responses);
            setDisabled(false);
        }
        catch (error) {
            setRequestTimedOut(true);
            setDisabled(false);
        }
    }), [roomSession.geolocation]);
    const requestFulfilled = (gpsResponse === null || gpsResponse === void 0 ? void 0 : gpsResponse.status) === streem_sdk_protobuf_1.WallItem.Artifact.Status.FULFILLED;
    const requestRejected = (gpsResponse === null || gpsResponse === void 0 ? void 0 : gpsResponse.status) === streem_sdk_protobuf_1.WallItem.Artifact.Status.REJECTED;
    const requestError = (gpsResponse === null || gpsResponse === void 0 ? void 0 : gpsResponse.status) === streem_sdk_protobuf_1.WallItem.Artifact.Status.ERROR;
    (0, react_1.useEffect)(() => {
        if (gpsResponse === null || gpsResponse === void 0 ? void 0 : gpsResponse.status) {
            setShowTooltip(true);
        }
    }, [gpsResponse]);
    const Message = () => {
        if (disabled) {
            return (0, jsx_runtime_1.jsx)(RequestSent, {});
        }
        else if (requestFulfilled) {
            return (0, jsx_runtime_1.jsx)(Location, {});
        }
        else if (requestRejected) {
            return (0, jsx_runtime_1.jsx)(PermissionDenied, {});
        }
        else if (requestError) {
            return (0, jsx_runtime_1.jsx)(ErrorEncountered, {});
        }
        else if (requestTimedOut) {
            return (0, jsx_runtime_1.jsx)(Unfulfilled, {});
        }
        else {
            return (0, jsx_runtime_1.jsx)(Request, {});
        }
    };
    const Address = ({ fullAddress }) => {
        const [streetAddress, city, stateZip] = fullAddress.split(', ');
        const [state, zip] = stateZip.split(' ');
        return ((0, jsx_runtime_1.jsxs)(ui_react_1.Column, Object.assign({ style: { marginBottom: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "dark", size: "small" }, { children: streetAddress })), (0, jsx_runtime_1.jsxs)(ui_react_1.AppText, Object.assign({ color: "dark", size: "small" }, { children: [city, ", ", state, ", ", zip] }))] })));
    };
    const Location = () => {
        const gpsPosition = gpsResponse === null || gpsResponse === void 0 ? void 0 : gpsResponse.gpsPosition;
        if (gpsPosition === null || gpsPosition === void 0 ? void 0 : gpsPosition.formattedAddress) {
            return ((0, jsx_runtime_1.jsx)(GPSResponseMessage, Object.assign({ text: 'Location', "data-testid": "gps-address" }, { children: (0, jsx_runtime_1.jsx)(Address, { fullAddress: gpsPosition.formattedAddress }) })));
        }
        else
            return (0, jsx_runtime_1.jsx)(Request, {});
    };
    const Unfulfilled = () => {
        return ((0, jsx_runtime_1.jsx)(GPSResponseMessage, { text: `Location request was not fulfilled.`, "data-testid": "gps-unfulfilled" }));
    };
    const PermissionDenied = () => ((0, jsx_runtime_1.jsx)(GPSResponseMessage, { text: `Your request for the GPS location was denied. You can request again.`, "data-testid": "gps-permission-denied" }));
    const ErrorEncountered = () => ((0, jsx_runtime_1.jsx)(GPSResponseMessage, { text: `There was a problem requesting the GPS location. You can request again.`, "data-testid": "gps-error" }));
    const GPSResponseMessage = (_a) => {
        var { text, children } = _a, props = __rest(_a, ["text", "children"]);
        return ((0, jsx_runtime_1.jsxs)(ui_react_1.Column, Object.assign({ style: { maxWidth: '200px' }, "data-testid": props['data-testid'] }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "dark", size: "small", style: { marginBottom: '8px' } }, { children: text })), children, (0, jsx_runtime_1.jsx)(Request, {})] })));
    };
    const RequestButton = (_a) => {
        var { children } = _a, props = __rest(_a, ["children"]);
        return ((0, jsx_runtime_1.jsx)(ui_react_1.Button, Object.assign({ variant: "tertiary", fontSize: "small", style: { paddingLeft: '15px' } }, props, { children: children })));
    };
    const InitialRequest = () => {
        if (isLockedOpen) {
            return ((0, jsx_runtime_1.jsxs)(ui_react_1.Column, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "dark", size: "small" }, { children: "Request location?" })), (0, jsx_runtime_1.jsxs)(ui_react_1.Row, Object.assign({ style: { justifyContent: 'flex-end' } }, { children: [(0, jsx_runtime_1.jsx)(RequestButton, Object.assign({ "data-testid": "sdk-gps-unlock-tooltip", onClick: () => {
                                    setShowTooltip(false);
                                    setIsLockedOpen(false);
                                } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(RequestButton, Object.assign({ "data-testid": "sdk-gps-request-geolocation", onClick: requestGeolocation }, { children: "Request" }))] }))] }));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ size: "small", color: "dark" }, { children: "Click to request location." })));
        }
    };
    const Request = () => {
        if (!(gpsResponse === null || gpsResponse === void 0 ? void 0 : gpsResponse.status)) {
            return (0, jsx_runtime_1.jsx)(InitialRequest, {});
        }
        if (isLockedOpen) {
            return ((0, jsx_runtime_1.jsx)(ui_react_1.Column, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Row, Object.assign({ style: { justifyContent: 'flex-end' } }, { children: (0, jsx_runtime_1.jsx)(RequestButton, Object.assign({ "data-testid": "sdk-gps-request", onClick: requestGeolocation, disabled: disabled }, { children: "Request again" })) })) }));
        }
        return ((0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ size: "small", color: "dark" }, { children: "Click to request location." })));
    };
    const RequestSent = () => {
        return ((0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ size: "small", color: "dark", style: { padding: '8px' } }, { children: "Location requested." })));
    };
    const handleClose = () => {
        if (isLockedOpen) {
            return;
        }
        else {
            setShowTooltip(false);
        }
    };
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Sensor, Object.assign({ onClickOutside: () => {
            setIsLockedOpen(false), setShowTooltip(false);
        }, onEscape: () => {
            setIsLockedOpen(false), setShowTooltip(false);
        } }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ message: (0, jsx_runtime_1.jsx)(Message, {}), offsetValue: -15, showTooltip: showTooltip, distance: 20 }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { "data-testid": "sdk-gps-toggle-tooltip-lock", background: "transparent", fill: ui_react_1.Theme.colors.azure, hoverFill: ui_react_1.Theme.colors.azureTransparent, highlight: "transparent", label: "GPS", title: "Request GPS location", iconName: "GPSIcon", onClick: () => {
                    setIsLockedOpen(!isLockedOpen);
                }, onMouseEnter: () => setShowTooltip(true), onMouseLeave: handleClose, onMouseOver: () => setShowTooltip(true) }) })) })));
}
exports.GPSbutton = GPSbutton;
//# sourceMappingURL=gps_button.js.map